import { render, staticRenderFns } from "./xitong-jibing.vue?vue&type=template&id=047f17df"
import script from "./xitong-jibing.vue?vue&type=script&lang=ts"
export * from "./xitong-jibing.vue?vue&type=script&lang=ts"
import style0 from "./xitong-jibing.vue?vue&type=style&index=0&id=047f17df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports